import { render } from "./SidebarEntries.vue?vue&type=template&id=dae4b62a"
import script from "./SidebarEntries.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarEntries.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/SidebarEntries.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dae4b62a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dae4b62a', __exports__)) {
    api.reload('dae4b62a', __exports__)
  }
  
  module.hot.accept("./SidebarEntries.vue?vue&type=template&id=dae4b62a", () => {
    api.rerender('dae4b62a', render)
  })

}


export default __exports__